export default __webpack_public_path__ + "static/media/Preview.b9c7deb3.svg";